import "../../../Css/NewTicket.css";
import React, { useEffect, useState, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import Config from "../../../Custom/Config";
//js
import {
  CallService,
  CallServiceExternal,
  modalAlert,
  signOut,
  getAllCompany,
  getFileType,
  handleFileUpload,
  handleImage,
  handleExcel,
  handlePDF,
} from "../../../Js/Script";
import { UseDepartment } from "../../../Js/Context/DepartmentCntx";
import { UseCategory } from "../../../Js/Context/CategoryCntx ";
import { UseUser } from "../../../Js/Context/userCntx";
import { UseOrganizaton } from "../../../Js/Context/OrganizationCntx";
import { UseTicket, SetTicket } from "../../../Js/Context/TicketCntx";

//material-ui
import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";
export default function NewTicket(props) {
  const {
    setShowNewResponseTicketComponent,
    responseTicket,
    ticketInformation,
  } = props;
  const Importance = [
    { title: "بحرانی", id: "1" },
    { title: "بالا", id: "2" },
    { title: "عادی", id: "3" },
    { title: "پایین", id: "4" },
  ];
  const TicketNewStatus = [
    { title: "در حال بررسی", id: "3" },
    { title: "پاسخ داده شده", id: "4" },
  ];
  const stUser = UseUser();
  const stDepartments = UseDepartment();
  const stOrganization = UseOrganizaton();
  const stCategory = UseCategory();
  const setTicket = SetTicket();
  const ticket = UseTicket();
  const [answer, SeAnswer] = useState([]);
  const [mainCategory, setMainCategory] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [categorych, setCategorych] = useState([]);

  const [searchText, setSearchText] = useState("");
  // const [questions, setQuestions] = useState([]);
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  // const [stopSearch, setStopSearch] = useState(true);
  const [searchResult, setSearchResult] = useState([]);

  // const [title, setTitle] = useState([]);

  const companyOptions = useMemo(() => {
    const list = getAllCompany(stDepartments, stOrganization);
    return Array.isArray(list) ? list.filter(Boolean) : [];
  }, [stDepartments, stOrganization]);

  const [states, setStates] = useState({
    ShowAlertInfo: true,
    ToTheGroup: "",
    User: "",
    insert: "",
    category: "",
    TicketCategoryAutoCompleteData: "",
    Title: "",
    Message: "",
    Files: "",
    ShowErrorTxt: { show: false, txt: "" },
    ShowSuccessTxt: { show: false, txt: "" },
    NewAnswerStatus: "",
    department: "",
    LastMessageSenderId: "",
    // Answer: "",
  });
  const navigate = useNavigate();
  const inputRefs = {
    Myfile: useRef(null),
    FileCount: useRef(null),
    fileArr: useRef([]),
  };

  const TicketValidation = () => {
    if (!states.category) {
      setStates((prevState) => ({
        ...prevState,
        ShowErrorTxt: {
          show: true,
          txt: "لطفاً یک دسته بندی را انتخاب نمایید",
        },
        ShowAlertInfo: false,
      }));

      return false;
    }

    if (!states.Title?.trim()) {
      setStates((prevState) => ({
        ...prevState,
        ShowErrorTxt: {
          show: true,
          txt: "لطفاً عنوان تیکت را وارد نمایید",
        },
        ShowAlertInfo: false,
      }));

      return false;
    }

    if (!states.Message?.trim()) {
      setStates((prevState) => ({
        ...prevState,
        ShowErrorTxt: {
          show: true,
          txt: "لطفاً متن پیام را وارد نمایید",
        },
        ShowAlertInfo: false,
      }));

      return false;
    }

    if (!states.User?.email || !states.User?.userId) {
      setStates((prevState) => ({
        ...prevState,
        ShowErrorTxt: {
          show: true,
          txt: "لطفاً کاربر را انتخاب نمایید",
        },
        ShowAlertInfo: false,
      }));

      return false;
    }

    if (!states.Importance?.id) {
      setStates((prevState) => ({
        ...prevState,
        ShowErrorTxt: {
          show: true,
          txt: "لطفاً اهمیت تیکت را انتخاب نمایید",
        },
        ShowAlertInfo: false,
      }));

      return false;
    }

    setStates((prevState) => ({
      ...prevState,
      ShowErrorTxt: {
        show: false,
        txt: "",
      },
      ShowAlertInfo: false,
    }));

    return true;
  };

  const SearchQuestion = (text) => {
    if (text.trim().length < 3) {
      setSearchResult([]);
      return;
    }

    CallServiceExternal(
      `Question/Get?Search=${encodeURIComponent(
        text,
      )}&pageNumber=1&pageSize=30`,
      null,
      "GET",
    )
      .then((res) => {
        setSearchResult((res?.items ?? []).filter(Boolean));
      })
      .catch((err) => {
        console.log(err);
        setSearchResult([]);
      });
  };

  useEffect(() => {
    if (responseTicket) return;
    const timer = setTimeout(() => {
      SearchQuestion(searchText);
    }, 400);

    return () => clearTimeout(timer);
  }, [searchText, selectedCategoryId]);

  function getMainProduct() {
    CallServiceExternal("Category/GetMainCategory/", null, "Get", false, false)
      .then((res) => {
        console.log("mainCategory:", res);
        console.log("isArray:", Array.isArray(res));
        setMainCategory(Array.isArray(res) ? res.filter(Boolean) : []);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  useEffect(() => {
    if (responseTicket) return;
    getMainProduct();
  }, []);

  function categoryData() {
    if (!selectedCategoryId) return;

    CallServiceExternal(
      `Category/GetSubCategory/${selectedCategoryId}`,
      null,
      "GET",
      false,
      false,
    )
      .then((res) => {
        setCategorych(Array.isArray(res) ? res.filter(Boolean) : []);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  useEffect(() => {
    if (responseTicket) return;
    categoryData();
  }, [selectedCategoryId]);

  const TicketAnswerValidation = () => {
    if (!states.Message) {
      setStates((prevState) => ({
        ...prevState,
        ShowErrorTxt: {
          show: true,
          txt: "لطفاً تمام فیلدهای الزامی را به دقت تکمیل نمایید",
        },
        ShowAlertInfo: false,
      }));
      // console.log("states", states);
    } else {
      setStates((prevState) => ({
        ...prevState,
        ShowErrorTxt: {
          show: false,
          txt: "",
        },
        ShowAlertInfo: false,
      }));
      return true;
    }
  };
  let arr = [];
  function updateFileCount(e) {
    const newFiles = Array.from(e.target.files);
    setTicket((prev) => ({
      ...prev,
      finalFile: Array.isArray(prev.finalFile)
        ? [...prev.finalFile, ...newFiles]
        : newFiles,
    }));
  }
  const removeFile = (index) => {
    setTicket((prev) => ({
      ...prev,
      finalFile: prev.finalFile.filter((_, i) => i !== index),
    }));
  };

  const answerStatus = (createrAnswered, newAnswerStatus) => {
    var answerStatus = "";
    if (newAnswerStatus) {
      if (newAnswerStatus && newAnswerStatus.id == "3") {
        answerStatus = "pending";
      } else {
        answerStatus = createrAnswered ? "createrAnswered" : "receiverAnswered";
      }
    } else {
      answerStatus = createrAnswered ? "createrAnswered" : "receiverAnswered";
    }
    return answerStatus;
  };
  const onAnswerTicket = (statusClose) => {
    var currentUser = localStorage.getItem("Name");
    if (TicketAnswerValidation()) {
      const url = `${Config.APIRoot}/TicketContent/${ticketInformation.ticketId}`;
      const data = {
        Status: statusClose,
        Message: states.Message,
        RegUserId: localStorage.getItem("id"),
        //
        LastMessageSenderId: localStorage.getItem("id"),
      };
      var createrAnswered =
        currentUser ==
        `${ticket.WriterUserInfo.writerFirstName} ${ticket.WriterUserInfo.writerLastName}`;
      var newAnswerStatus = states["NewAnswerStatus"];
      var answerStatusValue = answerStatus(createrAnswered, newAnswerStatus);
      let formData = new FormData();
      if (ticket["finalFile"] == null || !ticket["finalFile"].length) {
        formData.append("message", data.Message);
        formData.append("regUserId", data.RegUserId);
        formData.append("status", data.Status);
        formData.append("SystemTicket", 3);
        formData.append("answerStatus", answerStatusValue);
        formData.append("LastMessageSenderId", data.LastMessageSenderId);
        CallServiceFormData(url, formData);
      } else {
        handleFileUpload(ticket["finalFile"], (files) => {
          files.forEach((fileData) => {
            formData.append("Files", new Blob([fileData.data]), fileData.name);
          });
          formData.append("message", data.Message);
          formData.append("regUserId", data.RegUserId);
          formData.append("status", data.Status);
          formData.append("SystemTicket", 3);
          formData.append("answerStatus", answerStatusValue);
          formData.append("LastMessageSenderId", data.LastMessageSenderId); // جدید          // Now you can call your service function with formData
          CallServiceFormData(url, formData);
        });
      }
    }
  };
  //for send
  const onSendTicket = () => {
    if (responseTicket) {
      onAnswerTicket(true);
    } else {
      if (
        TicketValidation() &&
        states &&
        states.category &&
        states.Title &&
        states.Importance &&
        states.Importance.id &&
        states.Message &&
        states.User &&
        states.User.userId
      ) {
        const url = `${Config.APIRoot}/Tickets`;
        const data = {
          Title: states.Title,
          CategoryId: states.category,
          importanceGrade: states.Importance.id,
          Message: states.Message,
          TargetUserId: states.User.userId,
          RegUserId: states.User.userId,
          LastMessageSenderId: states.LastMessageSenderId,
        };
        let formData = new FormData();
        if (ticket["finalFile"] == null || !ticket["finalFile"].length) {
          formData.append("Title", data.Title);
          formData.append("CategoryId", data.CategoryId);
          formData.append("importanceGrade", data.importanceGrade);
          formData.append("Message", data.Message);
          formData.append("TargetUserId", data.TargetUserId);
          formData.append("WriterUserId", localStorage.getItem("id"));
          formData.append("RegUserId", data.RegUserId);
          formData.append("SystemTicket", 4);
          formData.append("answerStatus", "pending");
          formData.append("LastMessageSenderId", localStorage.getItem("id"));
          CallServiceFormData(url, formData);
        } else {
          handleFileUpload(ticket["finalFile"], (files) => {
            files.forEach((fileData) => {
              formData.append(
                "Files",
                new Blob([fileData.data]),
                fileData.name,
              );
            });
            formData.append("Title", data.Title);
            formData.append("CategoryId", data.CategoryId);
            formData.append("importanceGrade", data.importanceGrade);
            formData.append("Message", data.Message);
            formData.append("TargetUserId", data.TargetUserId);
            formData.append("WriterUserId", localStorage.getItem("id"));
            formData.append("RegUserId", data.RegUserId);
            formData.append("SystemTicket", 4);
            formData.append("answerStatus", "pending");
            formData.append("LastMessageSenderId", localStorage.getItem("id"));
            // Now you can call your service function with formData
            CallServiceFormData(url, formData);
          });
        }
      }
    }
  };
  const CallServiceFormData = (url, formData) => {
    fetch(url, {
      method: "POST",
      body: formData,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("Ticket")}`,
      },
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      credentials: "omit", // include, *same-origin, omit
      redirect: "follow", // manual, *follow, error
      referrer: "no-referrer", // no-referrer, *client
    })
      .then((response) => {
        try {
          if (
            response.status == 401 &&
            localStorage.getItem("sinadPlusTicket")
          ) {
            signOut();
          } else if (response.status == 500) {
            const err = "با خطای غیر منتظره مواجه شدید ";
            //setIsLoading(false);
            return err;
          } else {
            return response.text().then((text) => ({
              ok: response.ok,
              status: response.status,
              text,
            }));
          }
        } catch {
          modalAlert("با خطای غیر منتظره مواجه شدید برای ", "خطا");
        }
      })
      .then((result) => {
        const responseTxt =
          result && typeof result === "object" ? result.text : result;
        const isHttpError =
          result && typeof result === "object" && result.ok === false;

        try {
          var res = JSON.parse(responseTxt);

          if (isHttpError) {
            console.error("Server error", result.status, res);
            const details = res?.errors
              ? Object.entries(res.errors)
                  .map(([k, v]) => `${k}: ${v.join(", ")}`)
                  .join("\n")
              : res?.message || res?.title || responseTxt;
            modalAlert(details, "خطا", {
              type: "error",
              cancel: true,
              confirm: false,
              cancelCallBack: () => {
                // setIsLoading(false);
              },
            });
            return;
          }

          if (res.success === false) {
            modalAlert(res.message, "خطا", {
              type: "error",
              cancel: true,
              confirm: false,
              cancelCallBack: () => {
                // setIsLoading(false);
              },
            });
          } else {
            setTicket((prev) => ({ ...prev, finalFile: null }));
            if (!responseTicket) {
              setTicket((prevState) => ({
                ...prevState,
                ShowSuccessTxt: {
                  show: true,
                  txt: `درج تیکت با شناسه ${res.ticketIds} با موفقیت انجام شده است`,
                },
              }));
            } else {
              setTicket((prevState) => ({
                ...prevState,
                ShowSuccessTxt: {
                  show: true,
                  txt: `پاسخ به تیکت با شناسه ${ticketInformation.ticketId} با موفقیت انجام شده است`,
                },
              }));
            }
            navigate(-1);
          }
        } catch (e) {
          modalAlert(responseTxt, "خطا", {
            cancel: true,
            confirm: false,
            cancelText: "متوجه شدم.",
            cancelCallBack: () => {
              //setIsLoading(false);
            },
          });
        }
      })
      .catch((err) => {
        modalAlert(err, "خطا", {
          cancel: true,
          confirm: false,
          cancelCallBack: () => {
            //setIsLoading(false);
          },
        });
      });
  };
  // const CallServiceFormData = (url, formData) => {
  //   fetch(url, {
  //     method: "POST",
  //     body: formData,
  //     headers: {
  //       Authorization: `Bearer ${localStorage.getItem("Ticket")}`,
  //     },
  //     cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
  //     credentials: "omit", // include, *same-origin, omit
  //     redirect: "follow", // manual, *follow, error
  //     referrer: "no-referrer", // no-referrer, *client
  //   })
  //     .then((response) => {
  //       try {
  //         if (
  //           response.status == 401 &&
  //           localStorage.getItem("sinadPlusTicket")
  //         ) {
  //           signOut();
  //         } else if (response.status == 500) {
  //           const err = "با خطای غیر منتظره مواجه شدید ";
  //           //setIsLoading(false);
  //           return err;
  //         } else {
  //           return response.text();
  //         }
  //       } catch {
  //         modalAlert("با خطای غیر منتظره مواجه شدید برای ", "خطا");
  //       }
  //     })
  //     .then((responseTxt) => {
  //       try {
  //         var res = JSON.parse(responseTxt);
  //         if (res.success === false) {
  //           modalAlert(res.message, "خطا", {
  //             type: "error",
  //             cancel: true,
  //             confirm: false,
  //             cancelCallBack: () => {
  //               // setIsLoading(false);
  //             },
  //           });
  //         } else {
  //           setTicket((prev) => ({ ...prev, finalFile: null }));
  //           if (!responseTicket) {
  //             setTicket((prevState) => ({
  //               ...prevState,
  //               ShowSuccessTxt: {
  //                 show: true,
  //                 txt: `درج تیکت با شناسه ${res.ticketId} با موفقیت انجام شده است`,
  //               },
  //             }));
  //           } else {
  //             setTicket((prevState) => ({
  //               ...prevState,
  //               ShowSuccessTxt: {
  //                 show: true,
  //                 txt: `پاسخ به تیکت با شناسه ${ticketInformation.ticketId} با موفقیت انجام شده است`,
  //               },
  //             }));
  //           }
  //           navigate(-1);
  //         }
  //       } catch (e) {
  //         modalAlert(responseTxt, "خطا", {
  //           cancel: true,
  //           confirm: false,
  //           cancelText: "متوجه شدم.",
  //           cancelCallBack: () => {
  //             //setIsLoading(false);
  //           },
  //         });
  //       }
  //     })
  //     .catch((err) => {
  //       modalAlert(err, "خطا", {
  //         cancel: true,
  //         confirm: false,
  //         cancelCallBack: () => {
  //           //setIsLoading(false);
  //         },
  //       });
  //     });
  // };
  const onHandelTextArea = (e) => {
    const el = e.target;
    el.style.height = "111px";
    el.style.height = el.scrollHeight + "px";

    setStates((prev) => ({
      ...prev,
      Message: e.target.value,
    }));
  };

  const onKeyDownHandler = (e) => {
    setStates((prevState) => ({
      ...prevState,
      Message: prevState.Message,
    }));
  };

  return (
    <div className="ticket-page">
      <div className="ticket-card">
        <div className="ticket-header">
          <div>
            <h2>{responseTicket ? "پاسخ به تیکت" : "ثبت تیکت جدید"}</h2>

            <p>لطفاً اطلاعات زیر را تکمیل نمایید.</p>
          </div>

          <div className="ticket-required">تمامی فیلدهای * الزامی هستند.</div>
        </div>
        {/* <button className="panel-heading" id="newTicketHeading">
          {!responseTicket ? (
            <span>&#9733; تیکت جدید</span>
          ) : (
            <span>&#11179; پاسخ به تیکت</span>
          )}
          <span style={{ color: "gray" }}>
            {" "}
            (تمام فیلدهای ستاره دار الزامی می باشند){" "}
          </span>
        </button> */}
        <div>
          <div
            style={{ marginBottom: "10px" }}
            className={`alert-info alert-info-TicketHeading ${
              states.ShowAlertInfo ? "" : "alert-info-TicketHeading-hide"
            } `}
          >
            <span
              id="panel-heading-span"
              onClick={() => {
                setStates((prevState) => ({
                  ...prevState,
                  ShowAlertInfo: false,
                }));
              }}
            >
              ×
            </span>
            <p>
              <a href="https://knowledgebase.radisan.ir/">
                ممکن است با بررسی پایگاه دانش بتوانید پاسخ سئوال خود را راحت تر
                و در زمان کوتاه تری پیدا نمایید.
              </a>
            </p>
          </div>

          <div
            className={`alert-info alert-info-TicketHeading ${
              states.ShowFileAlertInfo ? "" : "alert-info-TicketHeading-hide"
            } `}
          >
            <span
              id="panel-heading-span"
              onClick={() => {
                setStates((prevState) => ({
                  ...prevState,
                  ShowFileAlertInfo: false,
                }));
              }}
            >
              ×
            </span>
            <p>.خطا فایل</p>
          </div>
          <div
            id="alertInfo"
            className={`alert-info ${
              states.ShowSuccessTxt && states.ShowSuccessTxt.show
                ? "alert-info-TicketHeading-show"
                : "alert-info-TicketHeading-hide"
            }`}
          >
            <strong>اطلاعات !</strong>
            <div className="d-flex">
              <span
                id="panel-heading-span"
                onClick={() => {
                  setStates((prevState) => ({
                    ...prevState,
                    ShowSuccessTxt: { show: false, txt: "" },
                  }));
                }}
              >
                ×
              </span>
              <p>{states.ShowSuccessTxt && states.ShowSuccessTxt.txt}</p>
            </div>
          </div>
          <div
            id="alertDanger"
            className={`alert-danger  ${
              states.ShowErrorTxt && states.ShowErrorTxt.show
                ? "alert-danger-TicketHeading-show"
                : "alert-danger-TicketHeading-hide "
            }`}
          >
            <strong>اطلاعات نامعتبر!</strong>
            <div className="d-flex">
              <span
                id="panel-heading-span"
                onClick={() => {
                  setStates((prevState) => ({
                    ...prevState,
                    ShowErrorTxt: { show: false, txt: "" },
                  }));
                }}
              >
                ×
              </span>
              <p>{states.ShowErrorTxt && states.ShowErrorTxt.txt}</p>
            </div>
          </div>
        </div>
        <div className="ticket-body">
          {!responseTicket && (
            <div className="ticket-form-row" id="toTheGroup">
              <label className="ticket-label">*به دپارتمان/گروه :</label>
              {/* <Autocomplete
              disablePortal
              options={getAllCompany(stDepartments, stOrganization)}
              value={states.department}
              onChange={(e, newValue) => {
                setStates((prev) => ({
                  ...prev,
                  department: newValue,
                }));
              }}
            /> */}
              <Autocomplete
                disablePortal
                options={companyOptions}
                getOptionLabel={(option) => option?.title ?? ""}
                isOptionEqualToValue={(option, value) =>
                  option?.id === value?.id
                }
                value={states.department}
                onChange={(e, newValue) => {
                  setStates((prev) => ({
                    ...prev,
                    department: newValue,
                  }));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    required
                    variant="outlined"
                    size="small"
                    fullWidth
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "12px",
                        background: "#fff",

                        "& fieldset": {
                          borderColor: "#DDE3EA",
                        },

                        "&:hover fieldset": {
                          borderColor: "#1976d2",
                        },

                        "&.Mui-focused fieldset": {
                          borderWidth: 2,
                        },
                      },
                    }}
                  />
                  // <TextField
                  //   {...params}
                  //   className="font-family-ticket font-family-ticket-input"
                  //   required
                  // />
                )}
                renderOption={(props, option) => {
                  if (!option) return null;
                  return (
                    <li {...props} key={option.id}>
                      <span className="font-family-ticket">{option.title}</span>
                    </li>
                  );
                }}
              />
            </div>
          )}
          {!responseTicket && stUser && states["department"] && (
            <div className="ticket-form-row" id="user">
              <label className="ticket-label">*کاربر :</label>
              <Autocomplete
                disablePortal
                options={
                  Array.isArray(stUser)
                    ? stUser.filter(
                        (user) =>
                          user &&
                          ((user.referenceId ===
                            states["department"]?.organizationId &&
                            user.referenceType === true) ||
                            (user.referenceId ===
                              states["department"]?.departmentId &&
                              user.referenceType === false)),
                      )
                    : []
                }
                getOptionLabel={(options) => {
                  if (options) {
                    return options.firstName + " " + options.lastName;
                  } else {
                    return "";
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    InputProps={{
                      ...params.InputProps,
                    }}
                    required
                    variant="outlined"
                    size="small"
                    fullWidth
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "12px",
                        background: "#fff",

                        "& fieldset": {
                          borderColor: "#DDE3EA",
                        },

                        "&:hover fieldset": {
                          borderColor: "#1976d2",
                        },

                        "&.Mui-focused fieldset": {
                          borderWidth: 2,
                        },
                      },
                    }}
                  />
                  // <TextField
                  //   className="font-family-ticket font-family-ticket-input"
                  //   {...params}
                  //   InputProps={{
                  //     ...params.InputProps,
                  //   }}
                  //   required
                  // />
                )}
                renderOption={(props, option) => {
                  if (!option) return null;
                  return (
                    <li {...props} key={option.userId}>
                      <span className="font-family-ticket">
                        {option.firstName + " " + option.lastName}
                      </span>
                    </li>
                  );
                }}
                value={states.User || ""}
                onChange={(e, newValue) => {
                  setStates((prev) => ({
                    ...prev,
                    User: newValue ? newValue : null,
                  }));
                }}
              />
            </div>
          )}
          {/* <div className="category-container">
          <span>* سامانه مورد نظر خود را انتخاب کنید:</span>

          <div className="category-list">
            {mainCategory.map((item) => (
              <div key={item.id}>{item.name}</div>
            ))}
          </div>
        </div> */}
          {!responseTicket && mainCategory.length > 0 && (
            <div className="category-container">
              <label className="ticket-label">
                * سامانه مورد نظر خود را انتخاب کنید:
              </label>

              <div className="category-list">
                {mainCategory.map((item) => (
                  <div
                    key={item.id}
                    className={`category-pill ${
                      selectedCategoryId === item.id ? "active" : ""
                    }`}
                    onClick={() => setSelectedCategoryId(item.id)}
                  >
                    {item.name}
                  </div>
                ))}
              </div>
            </div>
          )}
          {!responseTicket && selectedCategoryId && (
            <div className="ticket-form-row" id="ticketCategory">
              <label className="ticket-label">*دسته بندی تیکت :</label>
              <Autocomplete
                options={[...categorych]}
                getOptionLabel={(option) => option?.name || ""}
                value={categorych.find((x) => x.id === states.category) ?? null}
                onChange={(event, newValue) => {
                  console.log("========== CATEGORY CHANGE ==========");
                  console.log("Selected category:", newValue);
                  console.log("Previous Title:", states.Title);
                  console.log("======================================");

                  setStates((prev) => ({
                    ...prev,
                    category: newValue ? newValue.id : null,
                    // Title را اینجا پاک نکن
                  }));
                }}
                renderInput={(params) => (
                  <TextField {...params} placeholder="انتخاب دسته‌بندی" />
                )}
              />
            </div>
          )}
          {/* {!responseTicket && (
          <div className="ticket-form-row" id="ticketCategory">
            <span className="newTicket-span">*دسته بندی تیکت :</span>
            <Autocomplete
              className="newTicket-item"
              options={stCategory}
              getOptionLabel={(options) => {
                return options.categoryName;
              }}
              renderInput={(params) => (
                <TextField
                  className="damage-type-input font-family-ticket-input"
                  {...params}
                  InputProps={{
                    ...params.InputProps,
                  }}
                  required
                />
              )}
              renderOption={function (props, option) {
                return (
                  <li {...props}>
                    <span className="font-family-ticket">
                      {option.categoryName}
                    </span>
                  </li>
                );
              }}
              value={
                stCategory && states && states["category"] !== null
                  ? stCategory.find(
                      (option) =>
                        option.categoryId === states["category"].categoryId,
                    )
                  : null
              }
              onChange={(e, newValue) => {
                setStates((prev) => ({
                  ...prev,
                  category: newValue ? newValue.categoryId : null,
                }));
              }}
            />
          </div>
        )} */}
          {!responseTicket && (
            <div className="ticket-form-row" id="title">
              <label className="ticket-label">*عنوان :</label>
              <Autocomplete
                freeSolo
                options={searchResult}
                value={selectedQuestion}
                inputValue={searchText}
                filterOptions={(x) => x}
                getOptionLabel={(o) =>
                  typeof o === "string" ? o : (o?.title ?? "")
                }
                isOptionEqualToValue={(o, v) => o?.id === v?.id}
                onInputChange={(e, val, reason) => {
                  setSearchText(val);
                  if (reason === "input") {
                    setSelectedQuestion(null);
                    setStates((p) => ({ ...p, Title: val }));
                  }
                }}
                onChange={(e, val) => {
                  if (val && typeof val !== "string") {
                    setSelectedQuestion(val);
                    setSearchText(val.title);
                    setStates((p) => ({ ...p, Title: val.title }));
                  } else if (!val) {
                    setSelectedQuestion(null);
                    setSearchText("");
                    setStates((p) => ({ ...p, Title: "" }));
                  }
                }}
                renderOption={(props, option) => {
                  if (!option) return null;
                  return (
                    <li {...props} key={option.id}>
                      <div className="title-option">
                        <span className="title-option-main">
                          {option.title}
                        </span>
                        <small className="title-option-desc">
                          {option.description}
                        </small>
                      </div>
                    </li>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    size="small"
                    fullWidth
                    placeholder="عنوان سؤال را وارد کنید یا از لیست انتخاب کنید"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "12px",
                        background: "#fff",
                      },
                    }}
                  />
                )}
              />
            </div>
          )}
          {responseTicket && (
            <div className="ticket-form-row" id="newStatus">
              <label className="ticket-label"> وضعیت جدید تیکت:</label>
              <Autocomplete
                className="newTicket-item"
                options={TicketNewStatus}
                getOptionLabel={(options) => {
                  return options.title;
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    InputProps={{
                      ...params.InputProps,
                    }}
                    required
                    variant="outlined"
                    size="small"
                    fullWidth
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "12px",
                        background: "#fff",

                        "& fieldset": {
                          borderColor: "#DDE3EA",
                        },

                        "&:hover fieldset": {
                          borderColor: "#1976d2",
                        },

                        "&.Mui-focused fieldset": {
                          borderWidth: 2,
                        },
                      },
                    }}
                  />
                  // <TextField
                  //   className="damage-type-input font-family-ticket-input"
                  //   {...params}
                  //   InputProps={{
                  //     ...params.InputProps,
                  //   }}
                  //   required
                  // />
                )}
                renderOption={function (props, option) {
                  return (
                    <li {...props}>
                      {" "}
                      <span className="font-family-ticket">
                        {" "}
                        {option.title}{" "}
                      </span>{" "}
                    </li>
                  );
                }}
                value={states["NewAnswerStatus"] || null}
                onChange={(e, newValue) => {
                  setStates((prev) => ({
                    ...prev,
                    NewAnswerStatus: newValue ? newValue : null,
                  }));
                }}
              />
            </div>
          )}
          {!responseTicket && selectedQuestion && (
            <div className="ticket-form-row" id="message">
              <label className="ticket-label">پاسخ :</label>
              <textarea
                readOnly
                style={{
                  height: "111px",
                  resize: "both",
                  overflow: "auto",
                }}
                className="input-group-text newTicket-item font-family-ticket"
                onKeyDown={onKeyDownHandler}
                onChange={onHandelTextArea}
                value={selectedQuestion.description}
              />
            </div>
          )}
          <div className="ticket-form-row" id="message">
            <label className="ticket-label">* پیغام :</label>
            <textarea
              className="ticket-textarea"
              placeholder="شرح کامل درخواست خود را وارد نمایید..."
              style={{
                height: "111px",
                resize: "both",
                overflow: "auto",
              }}
              className="input-group-text newTicket-item font-family-ticket"
              onKeyDown={onKeyDownHandler}
              onChange={onHandelTextArea}
              value={states.Message}
            />
          </div>
          {!responseTicket && (
            <div className="ticket-form-row" id="Importance">
              <label className="ticket-label">*اهمیت :</label>
              <Autocomplete
                id="importantceOfTicket"
                className="newTicket-item"
                options={Importance}
                getOptionLabel={(options) => {
                  return options.title;
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    InputProps={{
                      ...params.InputProps,
                    }}
                    required
                    variant="outlined"
                    size="small"
                    fullWidth
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "12px",
                        background: "#fff",

                        "& fieldset": {
                          borderColor: "#DDE3EA",
                        },

                        "&:hover fieldset": {
                          borderColor: "#1976d2",
                        },

                        "&.Mui-focused fieldset": {
                          borderWidth: 2,
                        },
                      },
                    }}
                  />
                  // <TextField
                  //   className="damage-type-input font-family-ticket-input"
                  //   {...params}
                  //   InputProps={{
                  //     ...params.InputProps,
                  //   }}
                  //   required
                  // />
                )}
                renderOption={function (props, option) {
                  return (
                    <li className="font-family-ticket" {...props}>
                      <span className="font-family-ticket">{option.title}</span>
                    </li>
                  );
                }}
                value={states.Importance || null}
                onChange={(e, newValue) => {
                  setStates((prev) => ({
                    ...prev,
                    Importance: newValue ? newValue : null,
                  }));
                }}
              />
            </div>
          )}
          <div className="ticket-form-row">
            <label className="ticket-label">فایل های الحاقی:</label>
            {/* <div className="input-group-text" id="AdditionalFiles">
              <span
                className="btn-default"
                onClick={() => document.getElementById("myfile").click()}
                style={{ borderRadius: "0 4px 4px 0" }}
              >
                انتخاب فایل ها...
              </span>
              <label
                style={{ borderRadius: "4px 0px 0px 4px" }}
                htmlFor="myfile"
                // className="input-group-text"
              >
                Files selected:{" "}
                <span id="fileCount">
                  {ticket["finalFile"] ? ticket["finalFile"].length : 0}
                </span>
              </label>
            </div> */}
            <div>
              <div className="upload-box">
                <div className="upload-icon">📎</div>

                <div>
                  <div className="upload-title">
                    فایل های خود را انتخاب کنید
                  </div>
                  <div className="upload-subtitle">حداکثر حجم 50MB</div>
                </div>

                <button
                  type="button"
                  className="upload-btn"
                  onClick={() => document.getElementById("myfile").click()}
                >
                  انتخاب فایل
                </button>
              </div>
              {ticket["finalFile"] && ticket["finalFile"].length > 0 && (
                <div className="file-list">
                  {ticket["finalFile"].map((file, index) => (
                    <div className="file-item" key={index}>
                      <span className="file-name">
                        📄 {file.name}
                        <small> ({(file.size / 1024).toFixed(1)} KB)</small>
                      </span>
                      <button
                        type="button"
                        className="file-remove"
                        onClick={() => removeFile(index)}
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <input
              className="none"
              type="file"
              id="myfile"
              name="myfile[]"
              multiple
              onChange={(e) => {
                updateFileCount(e);
                e.target.value = "";
              }}
              ref={inputRefs.Myfile}
            />
          </div>
          <div className="ticket-footer">
            <button
              className="primary-btn"
              onClick={() => {
                onSendTicket();
              }}
            >
              {responseTicket ? "ارسال پاسخ" : "ارسال تیکت"}
            </button>
            {responseTicket && (
              <button
                className="btn-success m-0-5"
                id="responseTicketBtn"
                onClick={() => {
                  onAnswerTicket(false);
                }}
              >
                ارسال پاسخ و بستن تیکت
              </button>
            )}
            {responseTicket ? (
              <button
                className="secondary-btn"
                onClick={() => {
                  setShowNewResponseTicketComponent(false);
                }}
              >
                انصراف
              </button>
            ) : (
              <p
                id="newTicket-back"
                onClick={() => {
                  navigate(-1);
                }}
              >
                بازگشت به لیست تیکت ها
              </p>
            )}
          </div>
          <p className="hint">
            * محدودیت های فایل الحاقی: حداکثر حجم فایل 50MB - فرمت های مجاز :
            jpg, png, pdf, zip, rar, doc, docx, xls, xlsx, mp3, mp4
          </p>
        </div>
      </div>
    </div>
  );
}
